import { forwardRef, useImperativeHandle, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import BodyMapEntryTemplate from "../templates/BodyMapEntryTemplate";

interface Ref {
  show: () => void;
}

const CreateBodyMapEntryModal = forwardRef<Ref, unknown>((_, ref) => {
  const [showing, setShowing] = useState(false);

  useImperativeHandle(ref, () => ({
    show: () => {
      setShowing(true);
    },
  }));

  const handleClose = () => {
    setShowing(false);
  };

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      className="w-full max-w-[984px] mx-auto"
      title="Resident Body Map"
      hasCancelButton
    >
      <BodyMapEntryTemplate onClose={handleClose} />
    </ReusableModal>
  );
});

CreateBodyMapEntryModal.displayName = "CreateBodyMapEntryModal";
export { CreateBodyMapEntryModal };
